<template>
  <div class="announcements-notices">
    <notice
      v-for="announcement in announcements"
      :key="announcement.id"
      :announcement="announcement"
      @dismiss="dismiss($event)"
    />
  </div>
</template>

<script>
import axios from 'axios'
import Cookies from 'js-cookie'
import Notice from '@/Notice'

export default {
  name: 'Announcements',
  components: { Notice },

  data() {
    return {
      itemSlug: null,
      announcementsRaw: [],
      installedItems: [],
      dismissed: [],
    }
  },

  computed: {
    announcements() {
      return this.announcementsRaw.filter(announcement => {
        // don't display if announcement excluded for one of installed items
        if (announcement.exclude_for_installed && announcement.exclude_for_installed.length) {
          let has = this.installedItems.filter(x => announcement.exclude_for_installed.includes(x));
          if (has.length) {
            return false;
          }
        }

        // don't display dismissed announcement
        return this.dismissed.indexOf(announcement.id) === -1
      })
    },
  },

  mounted() {
    this.dismissed = Object.keys(Cookies.get())
        .filter(key => key.match(/^stm_item_announcement/))
        .map(key => parseInt(key.replace('stm_item_announcement_', '')))

    if (window.stmItemAnnouncements) {
      this.installedItems = window.stmItemAnnouncements.installedPlugins
    }

    axios.get(`https://stylemixthemes.com/api/announcements/${this.itemSlug}.json`).then((response) => {
      this.announcementsRaw = response.data
    })
  },

  methods: {
    dismiss(announcement) {
      this.dismissed.push(announcement.id)
      Cookies.set('stm_item_announcement_' + announcement.id, true, { expires: 60 })
    },
  },
}
</script>

<style scoped>
.announcements-notices {
  margin-top: 8px;
  width: 100%;
}
</style>
